module.exports = __webpack_public_path__ + "media/assets/images/tour/1_Tour_1-d184fbf6f7d4eed088b46f15b6c0b1f9.jpg";